import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

/**
 * Text Translate Anchor directive
 * Directive used together with translation that contain cliccable content with "ap-anchor" class.
 * Click on content emits the boolean true value
 *
 *
 * @example
 *  Suppose 'translate.key' equals to
 *  <strong>I'm a content with <a class="ap-anchor">subcontent cliccable</a></strong>
 *
 * If a component contains this html:
 *  <div apTextTranslateAnchor (anchorClicked)="someFunction($event)"> 'translate.key' | translate </div>
 *
 * When user click on link with class ap-anchor, the directive emits event with "anchorToGo" as content
 */
@Directive({
  selector: '[apTextTranslateAnchor]',
})
export class TextTranslateAnchorDirective {
  public el: ElementRef;

  @Output() anchorClicked = new EventEmitter<true>();

  constructor(el: ElementRef) {
    this.el = el;
  }

  @HostListener('click', ['$event'])
  onKeyDown(event: PointerEvent) {
    if ((event.target as Element).className === 'ap-anchor') {
      // const anchorValue = (event.target as Element).getAttribute('apanchor');

      this.anchorClicked.emit(true);
    }
    event.preventDefault();
    return false;
  }
}
